module.exports = __webpack_public_path__ + "static/media/bbc_news_live_election-us-2016-37825671_plot.ce61f1d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_live_election-us-2016-37825671_plot.png
// module id = 350
// module chunks = 0